import { motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

const TIERS = [
  { id: "short", name: "SHORT EDIT", spec: "UNDER 60 SEC", price: "FROM $10" },
  { id: "story", name: "STORY EDIT", spec: "UP TO 2 MIN", price: "FROM $15" },
  { id: "vlog", name: "VLOG EDIT", spec: "UP TO 5 MIN", price: "FROM $25" },
  { id: "long", name: "LONGER PROJECTS", spec: "DOCUMENTARY / SERIES / ONGOING", price: "CUSTOM QUOTE" },
];

export const Pricing = () => (
  <section
    id="pricing"
    data-testid="pricing-section"
    className="bg-[#0D0D0F] px-5 py-24 sm:px-10 sm:py-36"
  >
    <div className="mx-auto max-w-7xl">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        className="mb-8 block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs"
      >
        05 — PRICING
      </motion.span>

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display text-[clamp(2.6rem,7vw,6.5rem)] font-black uppercase leading-[0.9] tracking-tight text-[#F3F3F5]"
      >
        SIMPLE EDITS. <span className="text-[#8E8E93]">SIMPLE PRICING.</span>
      </motion.h2>

      <div className="mt-16 border-t border-white/10">
        {TIERS.map((t, i) => (
          <motion.button
            key={t.id}
            data-testid={`pricing-tier-${t.id}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.06 }}
            onClick={() => scrollToId("contact")}
            className="group grid w-full grid-cols-2 items-baseline gap-4 border-b border-white/10 py-7 text-left transition-colors duration-500 hover:bg-[#121215] sm:grid-cols-[1fr_1fr_auto] sm:py-9"
          >
            <h3 className="font-display text-2xl font-black uppercase tracking-tight text-[#F3F3F5] sm:text-4xl">
              {t.name}
            </h3>
            <span className="text-right font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93] sm:text-left sm:text-xs">
              {t.spec}
            </span>
            <span className="col-span-2 font-display text-3xl font-black uppercase text-[#F3F3F5] transition-colors duration-500 group-hover:text-[#E63946] sm:col-span-1 sm:text-5xl">
              {t.price}
            </span>
          </motion.button>
        ))}
      </div>

      <p className="mt-8 max-w-2xl font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-[#3a3a3f] sm:text-xs">
        * Final pricing can vary based on footage quantity, captions, complexity, turnaround,
        and revisions.
      </p>
    </div>
  </section>
);
